module.exports = __webpack_public_path__ + "img/page_sms_header.beb71b35.png";